module.exports = "precision mediump float;\n\nuniform mat4 proj;\nuniform mat4 model;\nuniform mat4 view;\n\nattribute vec3 position;\n\nvarying vec3 worldSpaceCoords;\nvarying vec4 projectedCoords;\n\nvoid main() {\n  worldSpaceCoords = (model * vec4(position + vec3(0.5, 0.5, 0.5), 1.0)).xyz;\n  gl_Position = proj * view * model * vec4(position, 1.0);\n  projectedCoords = proj * view * model * vec4(position, 1.0);\n}\n"


//////////////////
// WEBPACK FOOTER
// ./shaders/second-pass.vert.glsl
// module id = 59
// module chunks = 0